import { createRouter, createWebHashHistory } from "vue-router";
import { ElMessage } from 'element-plus';

const routes = [
  {
    path: "/",
    name: "首页",
    component: () => import("../views/layout"),
    redirect: '/home',
    children: [
      {
        path: "/home",
        name: "首页",
        component: () => import("../views/home/index"),
        meta: {
          title: '技能补给君 - 首页'
        }
      },
      {
        path: "/user",
        name: "用户管理",
        component: () => import("../views/user"),
        meta: {
          title: '技能补给君 - 用户管理'
        }
      },
      {
        path: "/swiper",
        name: "轮播图管理",
        component: () => import("../views/swiper"),
        meta: {
          title: '技能补给君 - 轮播图管理'
        }
      },
      {
        path: "/bigType",
        name: "产品大类管理",
        component: () => import("../views/bigType"),
        meta: {
          title: '技能补给君 - 产品大类管理'
        }
      },
      {
        path: "/smallType",
        name: "产品小类管理",
        component: () => import("../views/smallType"),
        meta: {
          title: '技能补给君 - 产品小类管理'
        }
      },
      {
        path: "/product",
        name: "产品管理",
        component: () => import("../views/product"),
        meta: {
          title: '技能补给君 - 产品管理'
        }
      },
      {
        path: "/order",
        name: "技单管理",
        component: () => import("../views/order"),
        meta: {
          title: '技能补给君 - 技单管理'
        }
      },
      {
        path: "/coinRecord",
        name: "充值记录管理",
        component: () => import("../views/coinRecord"),
        meta: {
          title: '技能补给君 - 充值记录管理'
        }
      },
      {
        path: "/modifyPassword",
        name: "修改密码",
        component: () => import("../views/modifyPassword"),
        meta: {
          title: '技能补给君 - 修改密码'
        }
      }
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login"),
    meta: {
      title: '技能补给君 - 登录'
    }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 添加全局前置守卫
router.beforeEach((to, from, next) => {

  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = '技能补给君后台管理系统';
  }

  // 获取存储的token和过期时间
  const token = window.sessionStorage.getItem("token");
  const expirationTime = window.sessionStorage.getItem("tokenExpiration");
  
  // 如果访问的不是登录页且token存在
  if (to.path !== '/login' && token) {
    // 检查token是否过期
    if (expirationTime && Date.now() > parseInt(expirationTime)) {
      // Token已过期
      ElMessage.warning('登录已过期，请重新登录');
      
      // 清除过期的存储信息
      window.sessionStorage.removeItem("token");
      window.sessionStorage.removeItem("tokenExpiration");
      window.sessionStorage.removeItem("userInfo");
      
      // 跳转到登录页
      next('/login');
      return;
    }
  }
  
  // 其他情况正常放行
  next();
});

export default router;
